import { defaultState } from "@/shared/utilities/constants";

export default () => ({
  studentsResult: { ...defaultState },
});
